/* eslint-disable */
import { BarChart } from 'chartist';
import styles from './styles.module.less';

let exportFn;

((root: Window & typeof globalThis | undefined, factory) => {
  if (root === undefined && window !== undefined) root = window;
  if (!root) { return; }
  exportFn = factory((root as any).Chartist);
  root['Chartist.plugins.ctButtonLabels'] = exportFn;
})(this, (Chartist) => {
  /**
   * Chartist.js plugin to make labels clickable
   */
  (() => {
    const defaultOptions = {
      labelClass: 'ct-label ct-vertical ct-start',
      labels: undefined,
      nonClickableLabels: undefined,
      reverse: true,
    };

    Chartist.plugins = Chartist.plugins || {};
    Chartist.plugins.ctButtonLabels = (options) => {
      options = Chartist.extend({}, defaultOptions, options);
      const labels = options.labels && [...options.labels];
      if (options.reverse) labels?.reverse();

      return function ctButtonLabels(chart) {
        const $chart = chart.container;
        if (chart instanceof BarChart) {
          chart.on('draw', () => {
            if (!options.onclick) return;

            const labelElements = $chart.getElementsByClassName(options.labelClass);
            let i = 0;
            // Why "for of" is used: https://stackoverflow.com/a/22754453
            for (const elem of labelElements) {
              const labelText = options.labels?.[i] ?? elem.textContent ?? elem.innerText ;
              if (!options.nonClickableLabels?.includes(labelText)) {
                elem.classList.add(styles.clickableChartLabel);
                elem.onclick = () => options.onclick?.(labelText);
              }
              i += 1;
            }
          });
        }
      };
    };
  })();

  return Chartist.plugins.ctButtonLabels;
});

export default exportFn;
